/**
 * Firefox has a bug where text selection breaks when using `transform: translateY()`
 * on absolutely positioned elements. The selection is painted from the DOM position
 * (top: 0) rather than the visual position. Using `top` positioning directly fixes this.
 * We maintain `transform` for other browsers as it is generally preferred for perf reasons.
 * See: https://bugzilla.mozilla.org/show_bug.cgi?id=1913308
 */
// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
const isFirefoxBrowser = typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent)

/**
 * Returns true if the current browser is Firefox.
 * Exported as a function to allow mocking in tests.
 */
export function isFirefox(): boolean {
  return isFirefoxBrowser
}
